// import React from "react";
import { LabRecentNotification } from "../Lab/LabOverview/LabRecentNotification";

// Latest notifications for the pharmacy dashboard. Uses the shared notification list, so times are
// shown in local time and a click opens the order. There is no type filter: notifications carry no
// type to filter on.
export const RecentNotification: React.FC = () => (
  <LabRecentNotification limit={8} marginTop={0} title="Recent Notifications" viewAllPath="/pharmacy-notifications" />
);

export default RecentNotification;
